import * as React from 'react';
import { useEffect, useState } from 'react';
import { Message } from '../../../common/Message';
import { TaxStatus } from '../interfaces/TaxInfo';

interface TaxFormDropdownProps {
    value?: TaxStatus;
    onChange: (value: string) => void;
}

const ExemptWarningMessage = () => {
    return (
        <React.Fragment>
            To verify your tax-exempt status, you have to email a copy of your tax exemption certificate to <a href="mailto:billing@lucidlink.com">billing@lucidlink.com</a>.
            If you do not provide it, you will be charged a sales tax.
        </React.Fragment>
    );
};

const STRIPE_DROPDOWN_ID = 'stripe-tax-dropdown';

export const StripeTaxStatusDropdown: React.FC<TaxFormDropdownProps> = ({ value = TaxStatus.Taxable, onChange }) => {
    const [status, setStatus] = useState(value);

    useEffect(() => {
        setStatus(value);
        onChange(value);
    },        [ value ]);

    return (
        <div className="stripe-custom-field stripe-custom-field--tax">
            <label htmlFor={STRIPE_DROPDOWN_ID}>Tax status</label>
            <div className="p-Select">
                <select
                    id={STRIPE_DROPDOWN_ID}
                    value={status}
                    className="Input p-Select-select"
                    onChange={(e) => {
                        onChange(e.target.value);
                        setStatus(e.target.value as TaxStatus);
                    }}
                >
                    <option value={TaxStatus.Taxable}>Taxable</option>
                    <option value={TaxStatus.Exempt}>Exempt</option>
                </select>
            </div>
            {status === 'exempt' && <Message message={ExemptWarningMessage()} isSuccess={false}/>}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/webportal/components/billing/details/stripe/StripeTaxStatusDropdown.tsx